// A client-side render of a mapping's {{payload.*}} / {{alert.*}} templates,
// for the Actions step's live preview (spec §20.2). The server's render (the
// Test step's Preview) is the exact one; this one only shows the shape while
// typing. Values come from the trigger's sample when the catalog sends one,
// else a placeholder naming the field.

const TOKEN = /\{\{\s*(payload|alert)\.([A-Za-z0-9_]+)\s*\}\}/g

export const sampleContext = trigger => {
  const payload = {}
  ;((trigger && trigger.schema) || []).forEach(f => { payload[f.key] = `‹${f.label}›` })
  Object.assign(payload, (trigger && trigger.sample) || {})
  const alert = trigger
    ? { kind: trigger.kind, label: trigger.label, category: trigger.category, severity: trigger.severity, raised_at: new Date().toISOString(), environment: '' }
    : {}
  return { payload, alert }
}

export const renderTemplate = (tpl, ctx) =>
  String(tpl || '').replace(TOKEN, (_, scope, key) => {
    const v = ctx[scope] && ctx[scope][key]
    return v === undefined || v === null ? '' : String(v)
  })

// The mapping actually in force: each key's own value, else the default.
export const effectiveMapping = (schema, value, defaults) => {
  const out = {}
  ;(schema || []).forEach(m => {
    const v = value[m.key]
    out[m.key] = v !== undefined && v !== '' && !(Array.isArray(v) && v.length === 0) ? v : defaults[m.key]
  })
  return out
}
